import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const REPORTS_REPORT_DESIGNER_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/reports/designer',
        iconClass: 'fas fa-object-group',
        name: 'CertReportService::ReportDesigner',
        parentName: '::Menu:Settings',
        layout: eLayoutType.application,
        requiredPolicy: 'CertReportService.ReportTemplates.Design',
      },
    ]);
  };
}
